'use client';

import { useAuth } from '@/hooks/useAuth';
import { Tooltip } from '@andritzot/metris-web-ui/data-display/tooltip';
import { Button } from '@andritzot/metris-web-ui/inputs/button';
import { type TabPanelHeaderTemplateOptions } from 'primereact/tabview';

const TabHeaderTemplate = ({ onClick, className, titleElement, ariaControls }: TabPanelHeaderTemplateOptions) => {
  const { isLoggedIn } = useAuth();

  const button = (
    <Button
      aria-controls={ariaControls}
      type="button"
      variant="text"
      disabled={!isLoggedIn}
      onClick={(e) => {
        onClick(e);
      }}
      className={className}
    >
      {titleElement}
    </Button>
  );

  if (!isLoggedIn) {
    return (
      <Tooltip title="You must be logged in to view this content" placement="top">
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
};

export default TabHeaderTemplate;
